import React from "react";
import { Col, Row } from "components/bootstrap";
import EntityCreateShareFormGroup from "components/permissions/EntityCreateShareFormGroup";
import { createGRN } from "logic/permissions/GRN";
import commonStyles from "../common/commonStyles.css";
const ShareForm = ({ onChange, eventDefinition }) => {
  var _a, _b, _c;
  const handleEntityShareSet = (entityShare) => onChange("share_request", entityShare);
  const streamDependenciesGRN = ((_b = (_a = eventDefinition == null ? void 0 : eventDefinition.config) == null ? void 0 : _a.streams) == null ? void 0 : _b.map((streamId) => createGRN("stream", streamId))) || [];
  const notificationDependenciesGRN = (_c = eventDefinition == null ? void 0 : eventDefinition.notifications) == null ? void 0 : _c.map(
    (notification) => createGRN("notification", notification.notification_id)
  );
  return /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 6, lg: 6 }, /* @__PURE__ */ React.createElement("h2", { className: commonStyles.title }, "Share ", /* @__PURE__ */ React.createElement("small", null, "(optional)")), /* @__PURE__ */ React.createElement(
    EntityCreateShareFormGroup,
    {
      description: "Search for a User or Team to add as collaborator on this event definition.",
      onSetEntityShare: handleEntityShareSet,
      entityType: "event_definition",
      entityTitle: "",
      dependenciesGRN: [...streamDependenciesGRN, ...notificationDependenciesGRN],
      defaultSharePayload: eventDefinition.share_request
    }
  )));
};
export default ShareForm;
